interface SocialMediaIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const SocialMediaIcon = (props: SocialMediaIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{
          fill: 'none', stroke: fillColor, strokeLinecap: 'round', strokeLinejoin: 'round',
        }}
        d="M28.47,17H23V12c0-3.59-4-2.67-4.14-2.58s.53,5.77-1.29,7.59a4.56,4.56,0,0,1-3.27,1.56h-.11v-.18a.92.92,0,0,0-.92-.92H9.73a.92.92,0,0,0-.92.92V29.58a.92.92,0,0,0,.92.92h3.54a.92.92,0,0,0,.92-.92v-.37a3,3,0,0,0,2.6,1.56h9.47a3.36,3.36,0,0,0,3.68-2.94l1.2-7.91A2.6,2.6,0,0,0,28.47,17Z"
      />
      <line
        style={{
          fill: 'none', stroke: fillColor, strokeLinecap: 'round', strokeLinejoin: 'round',
        }}
        x1="14.19"
        y1="29.28"
        x2="14.19"
        y2="18.45"
      />
    </svg>
  )
}

export default SocialMediaIcon
